import { useEffect, useState } from "react";

/**
 * Returns the current time and re-renders at an interval (live durations).
 *
 * @param nowMs - Clock in epoch milliseconds (injected).
 * @param intervalMs - Update interval.
 * @returns Epoch milliseconds.
 */
export function useNow(nowMs: () => number, intervalMs: number): number {
  const [now, setNow] = useState(nowMs);

  useEffect(() => {
    const handle = window.setInterval(() => {
      setNow(nowMs());
    }, intervalMs);
    const stop = (): void => {
      window.clearInterval(handle);
    };

    return stop;
  }, [nowMs, intervalMs]);

  return now;
}
